import { Flex } from "@/atoms"
import { IconTag } from "@/molecules/IconTag"

import type { DataDirectionTool } from "@/api/useInventory.types"

export const DataDirectionCell = (value: DataDirectionTool[]) => (
  <Flex align="center" gap={4}>
    {value.map((direction) => (
      <IconTag key={direction} text={direction} />
    ))}
  </Flex>
)
